export default [
  {
    path: '/class-attendances',
    name: 'class-attendance',
    meta: { requiresAuth: true },
    component: () => import('@/pages/class-attendance/index.vue')
  }
]
